import { useState } from 'react';
import { Icon } from './Icon';
import { Lightbox } from './Lightbox';
import './GalleryStrip.css';

const TEASER = 5;

function Tile({ item, onOpen }) {
    return (
        <button type="button" className="galTile" onClick={() => onOpen(item)}>
            {item.is_video ? (
                <video
                    className="galMedia"
                    src={item.url}
                    poster={item.frame}
                    muted playsInline loop
                    preload="metadata"
                    data-manual
                    onMouseEnter={(e) => { e.currentTarget.play().catch(() => {}); }}
                    onMouseLeave={(e) => { e.currentTarget.pause(); e.currentTarget.currentTime = 0; }}
                />
            ) : (
                <img className="galMedia" src={item.url} alt="" loading="lazy" />
            )}
            {item.is_video && <span className="galPlay"><Icon name="play" size={12} /></span>}
        </button>
    );
}

// "Your library": a one-row teaser that expands into the full grid, with a lightbox on click.
export function GalleryStrip({ items, token, kind, emptyHint }) {
    const [expanded, setExpanded] = useState(false);
    const [lightboxItem, setLightboxItem] = useState(null);
    const noun = `${kind}${items.length === 1 ? '' : 's'}`;
    const shown = expanded ? items : items.slice(0, TEASER);
    const hidden = items.length - shown.length;

    return (
        <section className="gal container">
            <div className="sectionHead">
                <div>
                    <div className="eyebrow">Your library</div>
                    <h2 className="sectionTitle">Your {kind}s</h2>
                </div>
                {items.length > 0 && <span className="sectionMeta">{items.length} {noun}</span>}
            </div>

            {items.length === 0 ? (
                <div className="galEmpty panel">
                    <span className="galEmptyIcon"><Icon name="sparkle" size={22} /></span>
                    <b>Your creations will appear here</b>
                    <span>{emptyHint}</span>
                </div>
            ) : (
                <>
                    <div className={`galGrid${expanded ? ' galGrid--expanded' : ''}`}>
                        {shown.map((item, i) => <Tile key={item.media_id || i} item={item} onOpen={setLightboxItem} />)}
                        {hidden > 0 && (
                            <button type="button" className="galTile galMore" onClick={() => setExpanded(true)}>
                                <span className="galMoreNum">+{hidden}</span>
                                <span>more</span>
                            </button>
                        )}
                    </div>
                    {expanded && items.length > TEASER && (
                        <div className="galCollapse">
                            <button type="button" className="btn btn--glass btn--sm" onClick={() => setExpanded(false)}>
                                <Icon name="arrowUp" size={14} /> Show less
                            </button>
                        </div>
                    )}
                </>
            )}

            {lightboxItem && (
                <Lightbox item={lightboxItem} items={items} token={token} onClose={() => setLightboxItem(null)} onChange={setLightboxItem} />
            )}
        </section>
    );
}
